import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IPermission } from '../../interfaces/IPermission';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {MatCardContent, MatCardHeader, MatCardTitle} from "@angular/material/card";
import {MatButton} from "@angular/material/button";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatInput} from "@angular/material/input";
import {NgForOf, NgIf} from "@angular/common";
import {MatCheckbox} from "@angular/material/checkbox";

@Component({
  selector: 'app-permissions-selector',
  templateUrl: './permissions-selector.component.html',
  standalone: true,
  imports: [
    MatCardHeader,
    MatButton,
    MatCardContent,
    MatFormField,
    MatInput,
    ReactiveFormsModule,
    NgForOf,
    MatCheckbox,
    MatLabel,
    MatCardTitle,
    NgIf,
    MatCheckbox
  ],
  styleUrls: ['./permissions-selector.component.css']
})
export class PermissionsSelectorComponent implements OnInit {
  @Input() availablePermissions: IPermission[] = [];
  @Input() selectedPermissions: IPermission[] = [];
  @Output() selectedPermissionsChange = new EventEmitter<IPermission[]>();

  searchControl = new FormControl('');
  filteredPermissions: IPermission[] = [];

  ngOnInit() {
    this.filterPermissions();
    this.searchControl.valueChanges.subscribe(() => this.filterPermissions());
  }

  filterPermissions() {
    const searchText = this.searchControl.value?.toLowerCase() || '';
    this.filteredPermissions = this.availablePermissions.filter(permission =>
      permission.Name.toLowerCase().includes(searchText)
    );
  }

  isPermissionSelected(permission: IPermission): boolean {
    return this.selectedPermissions.some(p => p.Value === permission.Value);
  }

  togglePermission(permission: IPermission) {
    const index = this.selectedPermissions.findIndex(p => p.Value === permission.Value);
    if (index === -1) {
      this.selectedPermissions.push(permission);
    } else {
      this.selectedPermissions.splice(index, 1);
    }
    this.selectedPermissionsChange.emit(this.selectedPermissions);
  }
}
